import {
  camelizeResponseData,
  decamelizeRequestBody,
} from 'src/utilities/http-data-casing';
import { sdk } from 'src/utilities/sdk';
import { InsightsDashboardReport } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/InsightsDashboard';
import { ReportFiltersPayload } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/reportFilters';

export const baseInsightsSingleReportUrl =
  '/targetedaudiencesgateway/corp-admin/insights';

export const getSingleInsightsReportUrl = (
  corpId: string,
  reportName: string
): string => `${baseInsightsSingleReportUrl}/dashboard/${corpId}/${reportName}`;

export async function fetchSingleInsightsReport(
  corpId: string,
  reportName: string,
  payload: ReportFiltersPayload
): Promise<InsightsDashboardReport> {
  const decamelizedPayload = decamelizeRequestBody(payload);

  const data = await sdk.http.post(
    getSingleInsightsReportUrl(corpId, reportName),
    decamelizedPayload
  );

  return camelizeResponseData(data) as InsightsDashboardReport;
}
